import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Loader } from '@eika/loader';
import { RadioButtonPanels } from '@eika/radio-button';
import { RadioButtonPanelOptions } from '@eika/radio-button/lib/Types';

import { EiendomWeb } from '../../generated-types';
import useEiendomregister from '../../hooks/useEiendom';
import { useTranslation } from '../../translations';
import { ANNEN_EIENDOM_ID, annenEiendom, AnnenEiendomFormData } from './annenEiendom';

export type ValgtEiendomFormData = {
    eiendom: EiendomWeb | undefined;
};

const EiendomList: FC = () => {
    const { eiendomList, validationMessage } = useTranslation();
    const { data: eiendommer, isLoading } = useEiendomregister();
    const {
        control,
        setValue,
        watch,
        unregister,
        formState: { errors },
    } = useFormContext<ValgtEiendomFormData & AnnenEiendomFormData>();
    const { eiendom } = watch();
    const getEiendommerOptions = () => {
        const eiendomOptions: RadioButtonPanelOptions[] = [];
        if (eiendommer) {
            eiendommer.forEach((e: EiendomWeb) => {
                eiendomOptions.push({
                    label: `${e.adresse}, ${e.postnummer} ${e.poststed}`,
                    value: e.eiendomId,
                });
            });
        }
        eiendomOptions.push({
            label: `${eiendomList.annenEiendom}`,
            value: ANNEN_EIENDOM_ID,
        });
        return eiendomOptions;
    };
    const setEiendom = (selectedEiendomId: string) => {
        unregister('poststed');
        if (selectedEiendomId === ANNEN_EIENDOM_ID) {
            const newEiendom: EiendomWeb = {
                ...annenEiendom,
                uuid: eiendom?.uuid || '',
            };
            setValue('eiendom', newEiendom);
        } else if (eiendommer) {
            const newEiendom: EiendomWeb = {
                ...eiendommer[eiendommer.findIndex((e) => e.eiendomId === selectedEiendomId)],
                uuid: eiendom?.uuid || '',
            };
            setValue('eiendom', newEiendom);
        }
    };

    if (isLoading) return <Loader />;

    return (
        <>
            <Controller
                name="eiendom.eiendomId"
                control={control}
                rules={{
                    validate: { ikkeValgt: (value: string) => value !== undefined && value !== '' },
                }}
                render={({ field: { onChange, value } }) => (
                    <RadioButtonPanels
                        label={eiendomList.title}
                        data-track-id="kreditt-boliglaan-velg-eiendom"
                        onChange={(value) => {
                            setEiendom(value);
                            onChange(value);
                        }}
                        selectedOption={value}
                        options={getEiendommerOptions()}
                        errorMessage={
                            errors.eiendom?.eiendomId?.type === 'ikkeValgt' ? `${validationMessage.requiredChoose}` : ''
                        }
                    />
                )}
            />
        </>
    );
};

export default EiendomList;
